<template>
    <div>
        <!-- <v-card v-if="dashboardLoading" class="pa-md-2 mt-2" elevation="0" width="100%">
            <LoadingSkeleton/>
        </v-card> -->
        <v-card
            id="YoigonotesState"
            class="mt-5 mx-auto"
            elevation="0"
            width="100%"
            :disabled="isLoading"
            :loading="isLoading"
        >
            <v-card-title primary-title>
                <v-row>
                    <v-col cols="12" align="center">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            class="primary--text text-overline text-center"
                        >
                            Resultados generales
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                                mt-n1
                            "
                        >
                            <v-icon large> mdi-google-analytics </v-icon>
                            Resultados generales
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <!-- <v-divider class="test"></v-divider> -->

            <v-card-text>
                <v-row no-gutters class="pt-2 mb-n5">
                    <v-col cols="12">
                        <v-sheet
                            class="v-sheet--offset mx-auto"
                            style="
                                background-color: rgb(0, 255, 128) !important;
                            "
                            elevation="2"
                            max-width="calc(100% - 32px)"
                        >
                            <v-sparkline
                                :labels="labels"
                                :value="value"
                                color="white"
                                line-width="2"
                                padding="16"
                            ></v-sparkline>
                        </v-sheet>
                    </v-col>
                </v-row>

                <v-row class="pt-8 pb-8 px-4">
                    <v-col
                        md="4"
                        cols="6"
                        v-for="(
                            index, accionesComercial
                        ) in accionesComercialesAllCount"
                        :key="accionesComercial"
                        align="center"
                    >
                        <v-hover v-slot="{ hover }">
                            <v-card
                                class="
                                    py-12
                                    px-2
                                    d-flex
                                    align-center
                                    justify-center
                                "
                                max-width="150px"
                                max-height="150px"
                                :elevation="hover ? 12 : 0"
                            >
                                <div class="pa-2">
                                    <v-row class="d-flex justify-center">
                                        <h4
                                            class="
                                               
                                                text-button
                                                text-wrap
                                                text-center
                                            "
                                        >
                                            {{
                                                accionesComercial
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                accionesComercial
                                                    .slice(1)
                                                    .replace('_', ' ')
                                            }}
                                        </h4>
                                    </v-row>
                                    <v-row class="d-flex justify-center">
                                        <h2
                                            class="
                                                numeral-text-2
                                                mt-2
                                                text-wrap text-center
                                            "
                                        >
                                            {{ index }}
                                        </h2>
                                    </v-row>
                                </div>
                            </v-card>
                        </v-hover>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';

export default {
    name: 'DashBoardYoigonotesState',

    data: () => ({
        labels: ['9am', '11am', '13am', '15am', '17pm', '19pm', '21pm'],
        value: [200, 675, 410, 390, 310, 460, 250],
    }),
    components: {
        LoadingSkeleton,
    },
    computed: {
        ...mapState('dashboard', {
            accionesComerciales: (state) =>
                state.estadisticaAccionesComerciales.accionesComerciales,
            isLoading: (state) =>
                state.estadisticaAccionesComerciales.isLoading,
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
        }),
        accionesComercialesAllCount() {
            let elements = {};

            this.accionesComerciales.forEach((element) => {
                Object.entries(element).forEach(([key, value]) => {
                    if (key != 'nombre_completo') {
                        if (key in elements) elements[key] += value;
                        else elements[key] = value;
                    }
                });
            });

            return Object.entries(elements)
                .sort((a, b) => a[1] < b[1])
                .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
        },
    },
};
</script>